import { Module } from 'vuex'

import { FreeSpaceStateModuleName } from '../modules'

import { GetJudgeDetailUseCase } from '@/application/judge/getJudgeDetailUseCase'
import { JudgeDetail } from '@/domain/entities/judge/judgeDetail'
import { JudgeRepository } from '@/domain/repositories/judge/JudgeRepository'

export type FreeSpaceJudgeDetailState = {
  judgeDetail: JudgeDetail | null
  isLoading: boolean
  error: string | null
}

export const freeSpaceJudgeDetailModule = (
  judgeRepository: JudgeRepository
): Module<FreeSpaceJudgeDetailState, any> => {
  const getJudgeDetailUseCase = new GetJudgeDetailUseCase(judgeRepository)

  return {
    namespaced: true,
    state: {
      judgeDetail: null,
      isLoading: false,
      error: null
    },
    mutations: {
      setJudgeDetail(state, { detail }: { detail: JudgeDetail }) {
        state.judgeDetail = detail
      },
      setLoading(state, isLoading: boolean) {
        state.isLoading = isLoading
      },
      setError(state, error: string | null) {
        state.error = error
      }
    },
    actions: {
      async getJudgeDetail({ commit }, { judgeId }: { judgeId: string }) {
        commit('setLoading', true)
        commit('setError', null)
        try {
          const res = await getJudgeDetailUseCase.getJudgeDetail(judgeId)
          commit('setJudgeDetail', { detail: res })

          // 画面表示用のエラーメッセージの保存
          if (res.runtimeError) {
            commit(`${FreeSpaceStateModuleName}/setErrorMessage`, { errorMessage: res.runtimeError }, { root: true })
            commit(`${FreeSpaceStateModuleName}/setIsErrorShow`, { isErrorShow: true }, { root: true })
          } else if (res.compileError) {
            commit(`${FreeSpaceStateModuleName}/setErrorMessage`, { errorMessage: res.compileError }, { root: true })
            commit(`${FreeSpaceStateModuleName}/setIsErrorShow`, { isErrorShow: true }, { root: true })
          } else {
            commit(`${FreeSpaceStateModuleName}/setErrorMessage`, { errorMessage: null }, { root: true })
          }
        } catch (e) {
          commit('setError', e)
        } finally {
          commit('setLoading', false)
        }
      }
    },
    getters: {
      judgeDetail: state => state.judgeDetail,
      isLoading: state => state.isLoading,
      error: state => state.error
    }
  }
}
